import { Badge, Tooltip } from '@mantine/core';
import { IconLockPin } from '@tabler/icons-react';
import SuperAdminGate from './SuperAdminGate';

const DEFAULT_TOOLTIP = 'Super admin only — not visible to regular users';

// Inline marker for super-admin-only settings. By default it renders only for
// super admins, so it can sit next to any label without leaking the concept to
// clients. Pass `show` when the caller already knows the answer — e.g. it
// receives `isSuperAdmin` as a prop, or the surrounding UI is gated by
// something other than the role (AlgorithmSelector gates by @releva.ai email).
const SuperAdminBadge = ({ label = 'Super admin', tooltip = DEFAULT_TOOLTIP, iconOnly = false, show, ...rest }) => {
  const badge = iconOnly ? (
    // `role="img"` is what makes the aria-label on a bare <svg> announced by
    // screen readers — without it the icon-only marker is invisible to AT.
    <IconLockPin
      size={14}
      color="var(--mantine-color-blue-6)"
      role="img"
      aria-label={label}
      data-super-admin="true"
      {...rest}
    />
  ) : (
    <Badge
      data-super-admin="true"
      color="blue"
      variant="light"
      size="sm"
      tt="none"
      leftSection={<IconLockPin size={12} />}
      {...rest}
    >
      {label}
    </Badge>
  );

  const content = tooltip ? (
    <Tooltip label={tooltip} withArrow>
      <span style={{ display: 'inline-flex', alignItems: 'center', cursor: 'help' }}>{badge}</span>
    </Tooltip>
  ) : (
    badge
  );

  if (show === undefined) {
    return <SuperAdminGate>{content}</SuperAdminGate>;
  }
  return show ? content : null;
};

export default SuperAdminBadge;
